import dangerSquareIcon from "@public/img/danger-square.svg";
import CloseIcon from "@public/img/close.svg";
import TextField from "@/component/widgets/text-field";
import TextareaField from "@/component/widgets/textarea-field";
import React, { useContext, useEffect, useState } from "react";
import { videoRepo } from "@/repo/video-repo";
import { AppContextType, WonmovContext } from "@/context/app-context";

export default function ReportsButton({ movieId, className }: { movieId: number; className?: string }) {
    var context = useContext<AppContextType>(WonmovContext);
    var isLoggedIn = context.isLoggedIn;
    var setNotification = context.setNotification;
    var modalState = useState(false);
    var isReportModalOpen = modalState[0];
    var setIsReportModalOpen = modalState[1];

    var handleSubmit = function (title: string, reason: string) {
        videoRepo.addReport(movieId, title, reason);
        setNotification({ type: "success", message: "گزارش با موفقیت ارسال شد" });
        setIsReportModalOpen(false);
    };

    if (!isLoggedIn) {
        return <></>;
    }

    var btnClass = className
        ? className
        : "movie-detail-hero__action-btn movie-detail-hero__action-btn--report";

    return (
        <>
            <img
                src={dangerSquareIcon}
                alt="ارسال گزارش"
                className={btnClass}
                onClick={function () {
                    setIsReportModalOpen(true);
                }}
            />

            {isReportModalOpen && (
                <ReportModal
                    onClose={function () {
                        setIsReportModalOpen(false);
                    }}
                    onSubmit={handleSubmit}
                />
            )}
        </>
    );
}

function ReportModal({
    onClose,
    onSubmit,
}: {
    onClose: () => void;
    onSubmit: (title: string, description: string) => void;
}) {
    var titleState = useState("");
    var title = titleState[0];
    var setTitle = titleState[1];
    var descriptionState = useState("");
    var description = descriptionState[0];
    var setDescription = descriptionState[1];

    useEffect(function () {
        var prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return function () {
            document.body.style.overflow = prev;
        };
    }, []);

    useEffect(function () {
        var onKey = function (e: KeyboardEvent) {
            if (e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", onKey);
        return function () {
            window.removeEventListener("keydown", onKey);
        };
    }, [onClose]);

    return (
        <div className="report-modal-overlay" onClick={onClose}>
            <div className="report-modal-overlay__wrap">
                <div className="report-modal-overlay__cell">
                    <div
                        className="report-modal"
                        dir="rtl"
                        onClick={function (e) {
                            e.stopPropagation();
                        }}
                    >
                        <div className="report-modal__header">
                            <p className="report-modal__title">ارسال گزارش</p>
                            <button type="button" className="report-modal__close" onClick={onClose}>
                                <img src={CloseIcon} alt="بستن" />
                            </button>
                        </div>

                        <div className="report-modal__body">
                            <div className="report-modal__field report-modal__field--title">
                                <TextField
                                    name="title"
                                    placeholder="عنوان گزارش"
                                    value={title}
                                    onChange={function (e) {
                                        setTitle(e.target.value);
                                    }}
                                />
                            </div>

                            <div className="report-modal__field">
                                <TextareaField
                                    name="description"
                                    placeholder="توضیحات گزارش"
                                    value={description}
                                    onChange={function (e) {
                                        setDescription(e.target.value);
                                    }}
                                />
                            </div>

                            <button
                                type="button"
                                className="report-modal__submit"
                                onClick={function () {
                                    onSubmit(title, description);
                                }}
                            >
                                ارسال گزارش
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
